export const FETCH_LOCKED_VISITS = "[GROUP_ADMIN] FETCH_LOCKED_VISITS";
export const FETCH_LOCKED_VISITS_START = "[GROUP_ADMIN] FETCH_LOCKED_VISITS_START";
export const FETCH_LOCKED_VISITS_SUCCESS = "[GROUP_ADMIN] FETCH_LOCKED_VISITS_SUCCESS";
export const FETCH_LOCKED_VISITS_ERROR = "[GROUP_ADMIN] FETCH_LOCKED_VISITS_ERROR";
export const SET_LOCKED_VISITS_PAGINATION = "[GROUP_ADMIN] SET_LOCKED_VISITS_PAGINATION";

export const fetchLockedVisits = (data) => {
    return {
        type: FETCH_LOCKED_VISITS,
        payload: data
    }
}